{
  "version": 1,
  "asset_id": "88ca5c88-a2bc-4b6a-b32b-056ae634f717",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/88ca5c88-a2bc-4b6a-b32b-056ae634f717/hernando-galvalume-metal-roof-destination-roofing-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/88ca5c88-a2bc-4b6a-b32b-056ae634f717/hernando-galvalume-metal-roof-destination-roofing-480w.avif",
  "original_filename": "hernando-galvalume-metal-roof-destination-roofing-480w.avif",
  "size": 18327,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
